var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"text-xs bg-illinois-black-5 border border-illinois-black-10 rounded px-2 py-1"},[_c('span',[_vm._v(_vm._s(_vm.t(_vm.message)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }